var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.62 44.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: currentColor;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.22,28a2,2,0,0,1-1.41-3.42L38.39,17A7.62,7.62,0,0,0,27.61,6.23L20,13.82A2,2,0,0,1,17.2,11L24.78,3.4A11.62,11.62,0,0,1,41.22,19.84l-7.59,7.58A2,2,0,0,1,32.22,28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.62,44.62A11.62,11.62,0,0,1,3.4,24.78l7.54-7.53a2,2,0,1,1,2.83,2.82L6.23,27.61A7.62,7.62,0,0,0,17,38.39l7.54-7.54a2,2,0,0,1,2.83,2.83l-7.54,7.54A11.57,11.57,0,0,1,11.62,44.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.46,32.17A2,2,0,0,1,13,28.75L28.75,13a2,2,0,1,1,2.83,2.83L15.87,31.58A2,2,0,0,1,14.46,32.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.9115b697.svg";
export { ForwardRef as ReactComponent };